import { IFromLibrarySettings } from 'core-components/sitebuilder/models/IWidget'
import { getTableProperties, IProperties } from 'core-components/sitebuilder/propertygenerator'
import { getAccordionFilterProperties } from 'core-components/sitebuilder/propertygenerator/adapter/AccordionFilter'

import { addCommonProperties } from './addCommonProperties'

const getDefaultProperties = (type: IFromLibrarySettings['type']) => {
  switch (type) {
    case 'AccordionFilter':
      return getAccordionFilterProperties()
    case 'Table':
      return getTableProperties()
    default:
      return []
  }
}

export const getPropertiesByType = (type: IFromLibrarySettings['type']): IProperties[] => {
  const properties = getDefaultProperties(type)

  return addCommonProperties(properties)
}
